import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { TIPO_SANGRE } from '../../constants/FieldsConst';
import { validFielddHelper } from '../../helpers/ValidFieldsHelper';

export const tiposSangreArray = [
  { id: 'A0', nombre: 'A-' },
  { id: 'A1', nombre: 'A+' },
  { id: 'B0', nombre: 'B-' },
  { id: 'B1', nombre: 'B+' },
  { id: 'AB0', nombre: 'AB-' },
  { id: 'AB1', nombre: 'AB+' },
  { id: 'O0', nombre: 'O-' },
  { id: 'O1', nombre: 'O+' },
];

export const getTipoSangre = (value) => {
  const d = tiposSangreArray.find((el) => el.id === value);
  return d.nombre;
};

const TiposSangreField = ({
  onChange,
  required,
  value,
  helperText,
  error,
  isSearch,
}) => {
  const xName = 'Tipo de sangre';

  const xSearch = (
    <Autocomplete
      disablePortal
      id={TIPO_SANGRE}
      options={tiposSangreArray}
      size="small"
      onChange={onChange}
      getOptionLabel={(option) => option.label}
      value={value}
      renderInput={(params) => (
        <TextField
          fullWidth
          label={xName}
          helperText={helperText ?? error ? validFielddHelper(1) : null}
          error={error}
          required={required ?? true}
          {...params}
        />
      )}
    />
  );

  const xSelect = (
    <FormControl fullWidth error={error} size="small" required>
      <InputLabel id={TIPO_SANGRE}>{xName}</InputLabel>
      <Select
        labelId={TIPO_SANGRE}
        id={TIPO_SANGRE}
        value={value}
        label={xName}
        onChange={onChange}
      >
        {tiposSangreArray.map((item) => {
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.nombre}
            </MenuItem>
          );
        })}
      </Select>
      {error ? (
        <FormHelperText>
          {helperText ?? error ? validFielddHelper(1) : null}
        </FormHelperText>
      ) : null}
    </FormControl>
  );

  return isSearch ? xSearch : xSelect;
};

TiposSangreField.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default TiposSangreField;
